<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Nota Fiscal da Conta {{data.contaId}}</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" matTooltip="Salvar" (click)="salvar()" [disabled]="form.invalid">
    <mat-icon>save</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12 col-xs-12 form-group">
        <p>A nota vale para todas as parcelas da conta que não estão canceladas nem substituídas.</p>
      </div>
    </div>

    <div class="row">
      <mat-form-field class="col-md-6 col-xs-12 form-group">
        <mat-label>Tipo da Nota</mat-label>
        <mat-select formControlName="tipoDocumentoFiscal">
          <mat-option *ngFor="let opcao of opcoesTipo" [value]="opcao.valor">
            {{opcao.texto}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-6 col-xs-12 form-group">
        <mat-label>Data de Emissão</mat-label>
        <input matInput [matDatepicker]="pickerDataEmissao" formControlName="dataEmissao">
        <mat-datepicker-toggle matSuffix [for]="pickerDataEmissao"></mat-datepicker-toggle>
        <mat-datepicker #pickerDataEmissao></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field class="col-md-6 col-xs-12 form-group">
        <mat-label>Número da Nota</mat-label>
        <input type="text" matInput formControlName="numero" maxlength="20">
      </mat-form-field>
      <mat-form-field class="col-md-6 col-xs-12 form-group">
        <mat-label>Série</mat-label>
        <input type="text" matInput formControlName="serie" maxlength="10">
      </mat-form-field>
    </div>

    <div class="row" *ngIf="carregou && parcelas.length === 0">
      <div class="col-md-12 col-xs-12 form-group">
        <p>A conta não tem parcelas que possam receber a nota fiscal.</p>
      </div>
    </div>

    <div class="row" *ngIf="parcelas.length > 0">
      <div class="col-md-12 col-xs-12">
        <table class="table" formArrayName="valoresBrutos">
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Nota atual</th>
              <th>Valor antes das Retenções</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let parcela of parcelas; let i = index; trackBy: trackByParcela">
              <td data-label="Parcela">{{parcela.contaParcelaId}} - {{parcela.descricao}}</td>
              <td data-label="Vencimento">{{parcela.dataVencimento | date:'dd/MM/yyyy'}}</td>
              <td data-label="Valor">{{parcela.valorParcela | currency:'BRL'}}</td>
              <td data-label="Nota atual">{{parcela.notaAtualFormatada}}</td>
              <td data-label="Valor antes das Retenções">
                <mat-form-field>
                  <input currencyMask matInput [formControlName]="i">
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</mat-dialog-content>
